const DATA = {
  URL: process.env.REACT_APP_SERVER_URL,
  pvtkey: process.env.REACT_APP_Pvt_Key,
};

export default DATA;
